import React, { useReducer } from 'react';
import { IApplicationData } from '../interfaces';
import { presentOrderReducer } from '../reducers';
import { ApplicationContext, ApplicationDispatchContext } from '../context';
import type { FCWithChildren } from '../../../types/FCWithChildren';

export const ApplicationProvider: FCWithChildren = ({ children }) => {
  const [state, dispatch] = useReducer(presentOrderReducer, {
    lenderUsers: null,
    partyModals: {},
  } as IApplicationData);

  return (
    <ApplicationContext.Provider value={state}>
      <ApplicationDispatchContext.Provider value={dispatch}>{children}</ApplicationDispatchContext.Provider>
    </ApplicationContext.Provider>
  );
};
